import { Constants } from "../constants/Contants";
import request from "../utils/useApi";

export const getAllListings = async (merchant) => {
  try {
    const res = await request.get(`${Constants.get_all_listings_api_url}/${merchant}`);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};

export const updateListing = async (listingId, data) => {
  try {
    const res = await request.patch(`${Constants.update_listing_api_url}/${listingId}`, data);
    if (res) {
      return res.data;
    }
  } catch (e) {
    throw e;
  }
};